var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgCheckmark = function SvgCheckmark(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "svg8",
    width: 24,
    height: 24,
    viewBox: "0 0 6.35 6.35",
    ref: ref
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(0 -290.65)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "rect831",
    fill: "currentColor",
    d: "M5.06 291.18a.2.2 0 0 0-.123.08l-2.545 3.648-1.072-1.088a.19.19 0 0 0-.27 0l-.465.472a.195.195 0 0 0 0 .273l1.859 1.847a.19.19 0 0 0 .269 0c.975-1.425 1.995-3 3.073-4.544a.195.195 0 0 0-.046-.27l-.537-.385a.19.19 0 0 0-.142-.033"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCheckmark);
export default ForwardRef;